module.exports = __webpack_public_path__ + "static/media/04-1.1c779bec.webp";